'use client';

import { useEffect } from 'react';
import { useAbTesting } from '@packages/shared/src/abtesting/useAbTesting/useAbTesting';

export type AiUspAbTestTrackerProps = {
  testId: string;
  sku: string;
};

/**
 * Client tracker for the AI USP AB test. Registers the shown product as the
 * "relevant product" for the test so outcomes can be attributed to the test.
 *
 * Rendered for both `control` and `test` participants (the server wrapper renders
 * the `AiUsp` bar as a sibling only for the `test` variant), so relevant-product
 * tracking is symmetric across both groups.
 *
 * `useAbTesting` is a client hook, so this bridges the async server wrapper
 * (which owns the variant/cookie logic) and the client-side AB test side effect.
 * It renders nothing itself.
 * TODO: This should be removed when the AB test is finished (INFORM-4237).
 */
export const AiUspAbTestTracker = ({ testId, sku }: AiUspAbTestTrackerProps) => {
  const { getRelevantProduct, setRelevantProduct, setOutcome } = useAbTesting();

  useEffect(() => {
    const wasAlreadyRelevant = getRelevantProduct(testId, sku).length > 0;

    if (!wasAlreadyRelevant) {
      setRelevantProduct(testId, sku);
      setOutcome(testId, { RPP_tr: '1' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testId, sku]);

  return null;
};
